export default {"src":"/_next/static/media/hand-holding-hand.c38c1378.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};